<template>

    <div class="app-checkbox-switch">
        <span class="label"><slot></slot></span>

        <label>
            <span class="control">
                <input type="checkbox"
                       v-model="newValue"
                       :placeholder="placeholderTrans"
                       @change="onInput">

                <span class="switch">
                    <span class="switch-toggle"></span>
                    <span class="switch-text switch-checked">{{ checkedText }}</span>
                    <span class="switch-text switch-not-checked">{{ uncheckedText }}</span>
                </span>
            </span>
        </label>

        <p class="message" v-if="message">{{ message }}</p>
    </div>

</template>

<script>

    export default {

        props: {
            value: [Boolean, Number, String],
            placeholder: String,
            checkedText: String,
            uncheckedText: String,
            checkedValue: {
                type: [Boolean, String, Number],
                default: true
            },
            uncheckedValue: {
                type: [Boolean, String, Number],
                default: false
            },
            error: Boolean,
            watchValue: Boolean,
            message: String
        },

        data() {
            return {
                newValue: this.value
            }
        },

        mounted() {
            if (this.checkedValue !== true && this.value == this.checkedValue) {
                this.newValue = true;
            }

            if (this.uncheckedValue !== false && this.value == this.uncheckedValue) {
                this.newValue = false;
            }
        },

        watch: {
            value() {
                if(! this.watchValue) {
                    return;
                }

                this.newValue = this.value;
            }
        },

        methods: {

            onInput() {
                const theValue = this.newValue ? this.checkedValue : this.uncheckedValue;

                this.$emit('input', theValue);
                this.$emit('change', theValue);
            }

        },

        computed: {
            placeholderTrans() {
                return this.placeholder ? $trans(this.placeholder) : '';
            }
        }

    }

</script>

<style lang="scss" scoped>

    .app-checkbox-switch {
        position: relative;

        label {
            display: flex;
            align-items: center;
        }

        .control {
            position: relative;
            cursor: pointer;
            margin-left: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            margin-top: 22px;

            span {
                display: block;
            }

            span.switch {
                width: 121px;
                height: 35px;
                border-radius: 23px;
                background-color: $white;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;

                .switch-text {
                    width: 100%;
                    font-size: 20px;
                    font-weight: $font-light;
                    height: 100%;
                    line-height: 33px;
                    color: $black;
                    text-align: center;
                    z-index: 1;
                    transition: all .2s ease-in-out;
                }

                .switch-toggle {
                    position: absolute;
                    width: 71px;
                    height: 35px;
                    border-radius: 23px;
                    background-color: $primary-blue;
                    transition: all .2s ease-in-out;
                }
            }

            input {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                opacity: 0;
                z-index: 2;
                cursor: pointer;

                &:checked {
                    + .switch {
                        .switch-checked {
                            color: $white;
                        }

                        .switch-toggle {
                            left: 50px;
                        }
                    }
                }

                &:not(:checked) {
                    + .switch {
                        .switch-not-checked {
                            color: $white;
                        }

                        .switch-toggle {
                            left: 0;
                        }
                    }
                }
            }

        }

        .label {
            font-size: 20px;
            font-weight: $font-light;
            letter-spacing: 0.8px;
            color: $black;
        }

        .message {
            font-size: 1em;
            margin: 10px 0 0;
            color: $error-red;
            font-weight: $font-normal;
        }

    }

</style>
